import React from 'react';
import ProfileGenerique from '../profile/ProfileGenerique';

export default function ProfileMagasinier() {
    return (
        <ProfileGenerique 
            role="magasinier" 
            title="📦 Mon profil magasinier"
            color="from-sky-600 to-blue-600"
        />
    );
}